/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import authStudentModule from './modules/auth/student/index.js';
import authTeacherModule from './modules/auth/teacher/index.js';
import popupModule from './modules/popup/index.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authStudent: authStudentModule,
    authTeacher: authTeacherModule,
    popup: popupModule,
  },
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== 'production',
});
